// Shared reCAPTCHA helpers for the form islands.
//
// Every widget is rendered explicitly so it owns a widget id: the implicit
// grecaptcha.getResponse()/reset() overloads address widget 0, and pages that carry more than
// one form (any chart page also carries the footer contact form) would otherwise read the wrong
// widget. api.js is loaded async, so rendering polls until grecaptcha is available.
export function renderRecaptcha(el, onRendered) {
  if (!el || !el.dataset.sitekey) return;

  const render = () => {
    if (!window.grecaptcha || !window.grecaptcha.render) return false;
    try {
      onRendered(window.grecaptcha.render(el, { sitekey: el.dataset.sitekey }));
    } catch (e) {
      /* already rendered */
    }
    return true;
  };

  if (render()) return;
  const iv = setInterval(() => { if (render()) clearInterval(iv); }, 300);
  setTimeout(() => clearInterval(iv), 10000);
}

export function recaptchaToken(widgetId) {
  return (window.grecaptcha && widgetId !== null) ? window.grecaptcha.getResponse(widgetId) : '';
}

export function resetRecaptcha(widgetId) {
  if (!window.grecaptcha || widgetId === null) return;
  try { window.grecaptcha.reset(widgetId); } catch (e) { /* widget may not be rendered */ }
}
